"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoAck = void 0;
exports.autoAck = {
    title: "Auto ask acknowledgement",
    subtitle: "Automatically ask the right people in the patient group to acknowledge a message.",
    addRule: "Add rule",
    editRule: "Edit rule",
    emptyTitle: "No auto-acknowledgement rules yet",
    emptyBody: "Create a rule and the people it matches will be asked to acknowledge the message automatically whenever one of the chosen events happens.",
    loadError: "Couldn’t load auto-acknowledgement rules. Check your connection and try again.",
    retry: "Retry",
    events: "Events",
    whenHappens: "When any of these happen",
    eventsHelper: "Template submissions and lab messages.",
    eventsRequired: "Pick at least one event.",
    askThesePeople: "Ask these people to acknowledge it",
    askHelper: "Only people who are in the patient’s group will be asked.",
    askThese: "Ask these people",
    orAlsoAsk: "OR also ask these people",
    and: "AND",
    or: "OR",
    onlyThoseWhoAre: "… only those who are",
    narrowThisDown: "+ Narrow this down",
    alsoAskDifferentSet: "+ Also ask a different set of people",
    remove: "Remove",
    removeCondition: "Remove this condition",
    who: "Who",
    "who._id": "Specific people by name",
    "who.department.id": "People in certain departments",
    "who.type": "People of a certain type",
    "who.firstName": "People whose first name is…",
    "who.lastName": "People whose last name is…",
    choose: "Choose…",
    namePlaceholder: "Type a name",
    nameHelper: "Matches whole words only, ignoring upper and lower case. “Alvarez” finds “Alvarez-Reyes”, but “Alv” finds nobody.",
    nameMatches_zero: "Matches nobody in the directory.",
    nameMatches_one: "Matches 1 person:",
    nameMatches_other: "Matches {{count}} people:",
    showAll: "+{{count}} more",
    showFewer: "Show fewer",
    conditionEmpty: "Pick at least one, or remove this condition.",
    valueTooLong: "Keep this under {{max}} characters.",
    tooManyValues: "Pick at most {{max}}.",
    onlyCertainPatients: "Only for certain patients (optional)",
    patientsHelper: "Leave this empty and the rule applies to every patient.",
    patientsStartingCareFor: "Patient start of care (SOC) by",
    anyPatient: "Any patient",
    allDisciplines: "The patient matches if start of care (SOC) is by any of these {{count}}.",
    forPatientsStarting: " for patients with start of care (SOC) by {{names}}",
    joinDisciplines: " or ",
    userType: {
        ADMIN: "Admin",
        STAFF: "Office staff",
        USER: "Field staff",
        PHYSICIAN: "Physician",
    },
    statusBlocked: "Blocked",
    statusDeleted: "Deleted",
    configuredCount_zero: "No users configured",
    configuredCount_one: "1 user configured",
    configuredCount_other: "{{count}} users configured",
    onlyGroupMembersAsked: "Only users who are members of the group will be asked to acknowledge.",
    readOnlyRuleHint: "This rule uses a condition this screen can’t edit yet. It stays exactly as it is when you save other rules.",
    cancel: "Cancel",
    save: "Save rule",
    saved: "Auto-ack rule saved",
    deleteTitle: "Delete this rule?",
    deleteBody: "{{events}} will no longer trigger an automatic acknowledgement request.",
    deleteIrreversible: "This can’t be undone.",
    delete: "Delete",
    deleted_success: "Auto-ack rule deleted",
};
